import { render, staticRenderFns } from "./redeems.vue?vue&type=template&id=045005e5&scoped=true"
import script from "./redeems.vue?vue&type=script&lang=js"
export * from "./redeems.vue?vue&type=script&lang=js"
import style0 from "./redeems.vue?vue&type=style&index=0&id=045005e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045005e5",
  null
  
)

export default component.exports